import type { FallbackRender } from '@sentry/react'
import * as React from 'react'

import { Helmet } from 'react-helmet-async'
import ErrorLayout from '../../layouts/Error/ErrorLayout'

const ErrorPage: FallbackRender = ({
  error,
  componentStack,
}): React.ReactElement => (
  <>
    <Helmet>
      <title>Something Went Wrong</title>
      <meta name="description" content="Something Went Wrong" />
    </Helmet>
    <ErrorLayout error={error} componentStack={componentStack} />
  </>
)

export default ErrorPage
